import React from 'react';
import { InputField, Box, Checkbox } from 'vindi-ds-components';

function PriceField() {
  return (
    <Box>
      <InputField
        label='Preço'
        type='number'
        placeholder='R$'
        name='pricing_schema_attributes.price'
      />
      <Box>
        <Checkbox label='Não definir preço do produto' />
      </Box>
    </Box>
  );
}

export default PriceField;
